import { useOnboardingSteps } from '@/viewmodel/features/onboarding/hooks/useOnboardingSteps';
import { completionPercent } from '@/viewmodel/features/onboarding/mappers/onboardingSteps';
import type { OnboardingChecklistViewState } from '@/viewmodel/features/onboarding/types';
import { useOnboardingCardViewModel } from '@/viewmodel/features/user';

export function useOnboardingChecklistViewModel(): OnboardingChecklistViewState {
  const { showCard } = useOnboardingCardViewModel();
  const steps = useOnboardingSteps();
  return { showCard, steps, percent: completionPercent(steps) };
}
